import React from 'react';
import './style.scss';
import { IContentSection, ITableOfContentItem } from '../page-template';
import PageTemplate from '../page-template/component';
import HeaderImg from '../../../assets/images/travbusiness-template-pages/10a22d0c-d24c-4cf9-815d-b06e0d9cd496.jpg'
import { useIntl } from 'react-intl';

const TravbusinessSolutionsForFinanceManagersPage: React.FC = () => {
  const intl = useIntl();
  const tocItems: ITableOfContentItem[] = [
    { id: 'centralized-billing', title: '1. Centralized Billing' },
    { id: 'customizable-spending-policies', title: '2. Customizable Spending Policies' },
    { id: 'dynamic-reporting-analytics', title: '3. Dynamic Reporting & Analytics' },
    { id: 'negotiated-corporate-rates', title: '4. Negotiated Corporate Rates' },
    { id: 'fraud-protection-support', title: '5. 24/7 Fraud Protection & Support' },
  ];
  
const sections: IContentSection[] = [
  {
    id: 'finance-mgrs.centralized-billing',
    title: intl.formatMessage({ id: 'finance-mgrs.centralized.billing' }),
    paragraphs: [
      intl.formatMessage({ id: 'finance-mgrs.centralized.billing.p1' }),
      intl.formatMessage({ id: 'finance-mgrs.centralized.billing.p2' }),
    ],
  },
  {
    id: 'finance-mgrs.customizable-spending-policies',
    title: intl.formatMessage({ id: 'finance-mgrs.customizable.spending.policies' }),
    paragraphs: [
      intl.formatMessage({ id: 'finance-mgrs.customizable.spending.policies.p1' }),
      intl.formatMessage({ id: 'finance-mgrs.customizable.spending.policies.p2' }),
    ],
  },
  {
    id: 'finance-mgrs.dynamic-reporting-analytics',
    title: intl.formatMessage({ id: 'finance-mgrs.dynamic.reporting.analytics' }),
    paragraphs: [
      intl.formatMessage({ id: 'finance-mgrs.dynamic.reporting.analytics.p1' }),
      intl.formatMessage({ id: 'finance-mgrs.dynamic.reporting.analytics.p2' }),
    ],
  },
  {
    id: 'finance-mgrs.negotiated-corporate-rates',
    title: intl.formatMessage({ id: 'finance-mgrs.negotiated.corporate.rates' }),
    paragraphs: [
      intl.formatMessage({ id: 'finance-mgrs.negotiated.corporate.rates.p1' }),
      intl.formatMessage({ id: 'finance-mgrs.negotiated.corporate.rates.p2' }),
    ],
  },
  {
    id: 'finance-mgrs.fraud-protection-support',
    title: intl.formatMessage({ id: 'finance-mgrs.fraud.protection.support' }),
    paragraphs: [
      intl.formatMessage({ id: 'finance-mgrs.fraud.protection.support.p1' }),
      intl.formatMessage({ id: 'finance-mgrs.fraud.protection.support.p2' }),
      intl.formatMessage({ id: 'finance-mgrs.fraud.protection.support.p3' }),
    ],
  },
];


  return (
    <div className="weeks-results-page">
      <PageTemplate
        headerImage={HeaderImg}
        headerTitle={intl.formatMessage({ id: 'finance-mgrs.headers.title' })}
        headerSubtitle={intl.formatMessage({ id: 'finance-mgrs.headers.subtitle' })}
        tableOfContents={tocItems}
        contentSections={sections}
        positionHeaderImg='center'
      />
    </div>
  );
};

export default TravbusinessSolutionsForFinanceManagersPage;
